import { Container } from './layout/';

export const FrontPageJumbotron = ({ children }) => (
  <div className="jumbotron">
    <Container>
      <div className="container">
        <div className="children">{children}</div>
        <svg
          className="coin"
          width="452"
          height="514"
          viewBox="0 0 452 514"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none">
            <path
              d="M324 329l-105 92c0-5-1-54-24-64-11-4-32-2-47 3-9 3-13 6-17 3-9-5-9-28-9-42 0-9 1-15-2-17-5-3-12 4-21 0-1 0-5-2-6-6-1-5 2-8 7-16 4-6 10-17 10-29 1-4 1-8-1-11-3-5-7-5-9-10-1-3 1-7 1-9a529 529 0 0 0 20-82c2-4 7-14 31-28 18-10 27-15 41-17 22-2 39 6 44 9 7 3 30 15 38 38 5 15 0 25 10 36 5 7 9 6 15 14 10 12 11 25 12 29 1 18-7 32-10 36-5 8-8 8-10 15 0 2-2 9 9 27 5 8 12 18 23 29z"
              stroke="var(--bgHotBlue__text)"
              strokeWidth="3"
            />
            <path
              d="M256 213c10-6 20-13 28-24l4-6M302 302c-1 0-26-3-28-15-1-4 0-8 1-12 2-8 6-13 9-17M273 285c-4 3-15 0-18-3-4-4-3-9-3-9l22-27"
              stroke="var(--bgHotBlue__text)"
              strokeWidth="3"
            />
            <path
              d="M252 274s-8-1-11-4-2-8-2-8l25-25M203 316c6-2 14-5 21-12 9-11 14-29 8-35l-3-2-19 2-18-26a27 27 0 0 1 31-5M116 160l16-1c-1-3-1-8 1-14 4-9 13-14 26-20 7-3 13-6 22-7h17"
              stroke="var(--bgHotBlue__text)"
              strokeWidth="3"
            />
            <path
              d="M132 159l15-1c2-6 6-12 12-18 21-19 51-11 54-10M147 158l23 1 12-12a188 188 0 0 1 44 3M170 159l9 11 19 2 32 6M179 170l-4 22a78 78 0 0 1 46 9M223 224c-5-7-9-10-13-11-6-2-9-2-21-3l-9-1-6 1c-1 1 4 4 7 9l1 10 10 14M175 192l-1 18"
              stroke="var(--bgHotBlue__text)"
              strokeWidth="3"
            />
            <path
              d="M229 21c0 4-3 8-8 8-4 0-7-4-7-8s3-7 7-7c5 0 8 3 8 7M277 32c0 5-4 8-8 8s-8-3-8-8c0-4 4-7 8-7s8 3 8 7M309 57c0 4-3 7-7 7s-8-3-8-7c0-5 4-8 8-8s7 3 7 8M340 85c0 4-3 7-7 7-5 0-8-3-8-7s3-8 8-8c4 0 7 4 7 8M365 125c0 4-3 8-8 8-4 0-7-4-7-8s3-8 7-8c5 0 8 4 8 8M378 168c0 4-3 7-7 7-5 0-8-3-8-7s3-8 8-8c4 0 7 4 7 8M396 253c0 5-4 8-8 8s-8-3-8-8c0-4 4-7 8-7s8 3 8 7M390 211c0 4-3 7-8 7-4 0-7-3-7-7 0-5 3-8 7-8 5 0 8 3 8 8M393 297c0 4-4 7-8 7s-8-3-8-7c0-5 4-8 8-8s8 3 8 8M382 342c0 5-3 8-7 8-5 0-8-3-8-8 0-4 3-7 8-7 4 0 7 3 7 7M367 386c0 4-3 7-7 7-5 0-8-3-8-7 0-5 3-8 8-8 4 0 7 3 7 8M341 421c0 4-3 8-7 8-5 0-8-4-8-8s3-8 8-8c4 0 7 4 7 8M309 452c0 5-3 8-7 8s-8-3-8-8c0-4 4-7 8-7s7 3 7 7M264 475c0 5-3 8-7 8s-8-3-8-8c0-4 4-7 8-7s7 3 7 7M215 484c0 4-4 7-8 7s-8-3-8-7c0-5 4-8 8-8s8 3 8 8M166 480c0 4-4 7-8 7s-7-3-7-7c0-5 3-8 7-8s8 3 8 8M122 461c0 5-3 8-8 8-4 0-7-3-7-8 0-4 3-7 7-7 5 0 8 3 8 7M85 429c0 4-4 7-8 7s-8-3-8-7c0-5 4-8 8-8s8 3 8 8M62 386c0 4-4 7-8 7s-8-3-8-7c0-5 4-8 8-8s8 3 8 8M43 335c0 4-3 7-8 7-4 0-7-3-7-7 0-5 3-8 7-8 5 0 8 3 8 8M35 287c0 4-4 7-8 7s-8-3-8-7c0-5 4-8 8-8s8 3 8 8M35 234c0 5-3 8-7 8-5 0-8-3-8-8 0-4 3-7 8-7 4 0 7 3 7 7M44 182c0 5-4 8-8 8s-8-3-8-8c0-4 4-7 8-7s8 3 8 7M62 127c0 4-3 7-7 7-5 0-8-3-8-7s3-8 8-8c4 0 7 4 7 8M94 85c0 4-3 7-7 7-5 0-8-3-8-7s3-8 8-8c4 0 7 4 7 8M131 48c0 4-4 8-8 8s-8-4-8-8 4-8 8-8 8 4 8 8M180 28c0 4-3 8-7 8s-8-4-8-8 4-8 8-8 7 4 7 8"
              fill="var(--bgHotBlue__text)"
            />
            <path
              d="M410 267c0 147-92 244-215 244S14 410 3 265C-8 118 84 11 206 3c123-9 204 117 204 264zM344 41l-15 2M409 199l27-3M415 228l26-4M417 252l27-3M418 279l23-3M418 302l20-1M376 417l19 4M389 396l19 3M398 374l21 2M405 352h23M412 330h21M406 173l20-2M390 125l19-2M399 148l17-1M380 104l16-3M369 84l13-3M350 62l15-4M362 436l17 4M347 454l18 3M331 469l17 3M309 484l17 2M286 496l14 3"
              stroke="var(--bgHotBlue__text)"
              strokeWidth="3"
            />
            <path
              d="M253 6c35 2 112 15 160 104 45 85 59 223-19 321-17 21-56 66-115 78-7 2-49 4-65 1"
              stroke="var(--bgHotBlue__text)"
              strokeWidth="3"
            />
          </g>
        </svg>
      </div>
    </Container>
    <style jsx>{`
      .jumbotron {
        background-color: var(--bgHotBlue);
        padding-bottom: 96px;
        overflow: hidden;
      }

      .container {
        position: relative;
        padding-top: 2vh;
        min-height: calc(100vh - 96px - 63px - 60px);
        box-sizing: border-box;
      }

      .container :global(h1) {
        margin: 0;
        font-size: 52px;
        line-height: 0.95;
        color: var(--bgHotBlue__text);
      }

      .container :global(p) {
        font-size: 28px;
        color: var(--bgHotBlue__text);
        line-height: 1.2;
        margin: 24px 0;
        font-weight: 500;
      }

      .coin {
        position: absolute;
        pointer-events: none;
        visibility: hidden;
      }

      .children {
        position: relative;
        z-index: 1;
      }

      @media screen and (min-width: 750px) {
        .container {
          padding-top: 0;
          display: flex;
          justify-content: center;
          flex-direction: column;
          min-height: 600px;
        }

        .container :global(h1) {
          max-width: 500px;
        }

        .container :global(p) {
          max-width: 580px;
        }

        .coin {
          right: -100px;
          bottom: -120px;
          width: 600px;
          height: auto;
          visibility: visible;
          opacity: 0.6;
        }
      }

      @media screen and (min-width: 1100px) {
        .coin {
          opacity: 1;
        }
      }
    `}</style>
  </div>
);
